import { Link } from 'react-router-dom'
import { ADDRESS_PATHS, ADDRESS_UI, type SavedAddressListProps } from '../constants/addresses'
import { ORDER_PATHS } from '../constants/orders'
import { nationalPhoneDigits } from '../helpers/orders'
import { Icon } from './Icon'

export function SavedAddressList({
  addresses,
  selectedId,
  disabled = false,
  onSelect,
}: SavedAddressListProps) {
  if (addresses.length === 0) return null

  return (
    <fieldset className="saved-addresses" disabled={disabled}>
      <legend>{ADDRESS_UI.heading}</legend>
      <p className="saved-addresses__lead">{ADDRESS_UI.lead}</p>
      <ul className="saved-addresses__list">
        {addresses.map((address) => {
          const selected = address.id === selectedId
          return (
            <li key={address.id}>
              <div
                className={`saved-addresses__card${selected ? ' is-selected' : ''}`}
                onClick={() => onSelect(address.id)}
              >
                <div className="saved-addresses__radio-wrap">
                  <input
                    type="radio"
                    name="saved-address"
                    checked={selected}
                    onChange={() => onSelect(address.id)}
                    aria-label={`Select address for ${address.recipientName}`}
                  />
                </div>
                <div className="saved-addresses__body">
                  <div className="saved-addresses__header">
                    <strong className="saved-addresses__name">{address.recipientName}</strong>
                    <Link
                      to={ADDRESS_PATHS.edit(address.id)}
                      state={{ returnTo: ORDER_PATHS.checkout }}
                      className="saved-addresses__edit-btn"
                      onClick={(e) => e.stopPropagation()}
                      aria-label={ADDRESS_UI.editAria(address.recipientName)}
                    >
                      <Icon name="pencil" size={13} />
                      <span>{ADDRESS_UI.edit}</span>
                    </Link>
                  </div>
                  <p className="saved-addresses__text">{address.address}</p>
                  <div className="saved-addresses__meta">
                    <span className="saved-addresses__city">
                      {address.city}
                      {address.pincode ? `, ${address.pincode}` : ''}
                    </span>
                    <span className="saved-addresses__phone">
                      <Icon name="phone" size={13} />
                      {nationalPhoneDigits(address.recipientPhone)}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          )
        })}
        <li>
          <div
            className={`saved-addresses__card saved-addresses__card--new${!selectedId ? ' is-selected' : ''}`}
            onClick={() => onSelect(null)}
          >
            <div className="saved-addresses__radio-wrap">
              <input
                type="radio"
                name="saved-address"
                checked={!selectedId}
                onChange={() => onSelect(null)}
                aria-label={ADDRESS_UI.useNew}
              />
            </div>
            <div className="saved-addresses__body">
              <strong className="saved-addresses__new-title">{ADDRESS_UI.useNew}</strong>
            </div>
          </div>
        </li>
      </ul>
    </fieldset>
  )
}

